import React from 'react'
import InputDateUI from './InputDateUI'

const InputDateTimeUI = (props) => (
  <InputDateUI
    {...props}
    showTimeSelect={true}
  />
)

export default InputDateTimeUI